import { render } from "./DisplayedProduct.vue?vue&type=template&id=527e8600&scoped=true"
import script from "./DisplayedProduct.vue?vue&type=script&lang=js"
export * from "./DisplayedProduct.vue?vue&type=script&lang=js"

import "./DisplayedProduct.vue?vue&type=style&index=0&id=527e8600&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527e8600"]])

export default __exports__